<!--begin::Header container-->
<div
  id="kt_app_header_container"
  class="app-container container-fluid d-flex align-items-stretch"
>
  <!--begin::Header menu toggle-->
  <div class="d-lg-none align-items-center d-flex" title="Show header menu">
    <div
      class="btn btn-icon w-35px h-35px"
      type="button"
      id="kt_app_header_menu_toggle"
      (click)="toggleSideBar()"
    >
      <svg
        *ngIf="!toggle"
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        fill="currentColor"
        class="bi bi-list"
        viewBox="0 0 16 16"
      >
        <path
          fill-rule="evenodd"
          d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
        />
      </svg>

      <svg
        *ngIf="toggle"
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        fill="currentColor"
        class="bi bi-x-lg"
        viewBox="0 0 16 16"
      >
        <path
          d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"
        />
      </svg>
    </div>
  </div>
  <!--end::Header menu toggle-->

  <ng-container class="appSidebarDisplay">
    <!--begin::Mobile logo-->
    <div class="d-flex align-items-center flex-grow-1 flex-lg-grow-0">
      <a routerLink="/dashboard" class="d-lg-none">
        <img alt="Logo" src="./assets/img/logo-sm.png" class="h-50px" />
      </a>
    </div>
    <!--end::Mobile logo-->
  </ng-container>
</div>
<!--end::Header container-->
